import React, { useEffect, useState } from "react";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Button,
  TextField,
  Typography,
  TablePagination,
  InputAdornment,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import './LoansCancelledRequests.scss';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { commonRunQuery, getListOfLoansToApprove, loanApprove, loanCancel, loanPaymentPlanRetrieve } from "../../util/API/loans";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format, parseISO } from "date-fns";
import SearchIcon from "@mui/icons-material/Search";
import CustomInputAlert from "../UI/CustomInputAlert/CustomInputAlert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import LoanDetails4Pay from "../LoanDetails4Pay/LoanDetails4Pay";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";

const LoansCancelledRequests = ({
    selectedProductLoan,
    selectedUser,
    setAlert,
    setViewCancelledLoans
}) => {
    const [searchText, setSearchText] = useState("");
    const [loanList, setLoanList] = useState([]);
    const [allLoans, setAllLoans] = useState([]);
    const [showInputAlert, setShowInputAlert] = useState(false);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const authUser = sessionStorage.getItem("user");
    const parsedAuthUser = JSON.parse(authUser);
    const [startDate, setStartDate] = useState(dayjs().subtract(30, "day")); // Default to 30 days ago
    const [endDate, setEndDate] = useState(dayjs());
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openLoanDetailsDrawer, setOpenLoanDetailsDrawer] = useState(false);
    const [loanDetailsArr, setDetailsArr] = useState(false);
    const [userLoanPaymentPlans, setUserLoanPaymentPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        backgroundColor: "rgba(0,0,0, .1)",
        color: theme.palette.common.black,
        fontWeight: "bold",
        textAlign:"center",
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 25,
        fontWeight: "600",
        },
    }));

    useEffect(()=> {
        getCancelledRequests();
    },[selectedUser, selectedProductLoan]);

    const getCancelledRequests = async() => {
        try {
            const response = await commonRunQuery(281, `${selectedUser}/${selectedProductLoan?.productcode}`);
            console.log("getCancelledRequests_response=======================",response);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanRequestsArray = Array.isArray(response?.data?.body?.record)
                  ? response?.data?.body?.record
                  : [response?.data?.body?.record];
                
                console.log("getLoansList_loanRequestsArray=======================",loanRequestsArray);
                setLoanList(loanRequestsArray);
                setAllLoans(loanRequestsArray);
            } else if(response?.data?.header?.reccount === "0") {
                setLoanList([]);
                setAllLoans([]);
            }
        } catch (error) {
            console.log("getLoansList_error=======================",error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = () => {
        if (!searchText.trim()) {
            setLoanList(allLoans); // Reset to original data if search is cleared
            return;
        }
    
        const filteredLoans = allLoans.filter((row) => {
            return (
                row?.loanrequests?.currcode?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanrequests?.requestamount?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanrequests?.requestdate?.toString().includes(searchText) ||
                row?.loanrequests?.requestid?.toLowerCase().includes(searchText.toLowerCase())
            );
        });
    
        setLoanList(filteredLoans);
    }

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleViewDetails = (loan) => {
        setSelectedLoan(loan);
        setOpenDetailsDialog(true);
        handleMenuClose(); // close the menu
    };

    return (
        <Box className="loan-assignment-container">
            {
                isLoading ? 
                    (
                        <div className="text-center mt-5">
                            <span className="loader" />
                        </div>
                    ) :
                <>
                    <Box className="d-flex justify-content-between">
                        <Typography
                            sx={{
                                fontFamily: "'Nunito'",
                                fontStyle: "normal",
                                fontWeight: 500,
                                fontSize: "21.4825px",
                                color: "#3A3A3A",
                            }}
                            className=""
                        >
                            Cancelled Loan Requests
                        </Typography>
                        <Box>
                            <Button
                                className="fs-size-12 paiy-blue text-white"
                                variant="contained"
                                color="primary"
                                onClick={() => setViewCancelledLoans(false)}
                            >
                                Return
                            </Button>
                        </Box>
                    </Box>

                    <Box>
                        <Box className="search-container">
                            <TextField
                                placeholder="Search by currency code, Requested amount, etc."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                variant="standard"
                                fullWidth
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        handleSearch(); // Call your function on Enter key press
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    sx: {
                                    borderRadius: "33px",
                                    color: "#000",
                                    },
                                    endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleSearch} edge="end">
                                        <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                    ),
                                }}
                                // InputProps={{ disableUnderline: true }}
                                sx={{ fontSize: "14px", borderRadius: "33px" }}
                            />
                        </Box>

                        {/* Date Pickers */}
                        {/* <Box className="d-flex mt-3 gap-3">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    inputFormat="YYYY-MM-DD"
                                    label="Start Date"
                                    fullWidth
                                    margin="normal"
                                    onChange={(newValue) => setStartDate(dayjs(newValue))}
                                    value={startDate.toDate()}
                                    InputLabelProps={{ 
                                        shrink: true,
                                        style: {
                                        fontSize: '12px',
                                        color: "inherit !important"
                                        }
                                    }}
                                    sx={{
                                        width: '25%', 
                                        marginTop: 2,
                                        marginBottom: 2,
                                        '& input': {
                                        padding: '8px 12px',
                                        color: "inherit !important"
                                        },
                                    }}
                                />

                                <DatePicker
                                    inputFormat="YYYY-MM-DD"
                                    label="End Date"
                                    fullWidth
                                    margin="normal"
                                    onChange={(newValue) => setEndDate(dayjs(newValue))}
                                    value={endDate.toDate()}
                                    InputLabelProps={{ 
                                        shrink: true,
                                        style: {
                                            fontSize: '12px',
                                            color: "inherit !important"
                                        }
                                    }}
                                    sx={{
                                        width: '25%', 
                                        marginTop: 2,
                                        marginBottom: 2,
                                        '& input': {
                                            padding: '8px 12px',
                                            color: "inherit !important"
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Box> */}
                    </Box>
                    
                    <Box className="mt-4">
                        <TableContainer className="approved-loans-table-container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Currency Code</StyledTableCell>
                                        <StyledTableCell>Request Amount</StyledTableCell>
                                        <StyledTableCell>Request Date</StyledTableCell>
                                        <StyledTableCell>Request ID</StyledTableCell>
                                        <StyledTableCell>Action</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    // loanList && loanList.length > 0 && loanList.map((row, index) => (
                                    loanList && loanList.length > 0 ? loanList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center" className="">
                                                <div>{row?.loanrequests?.currcode}</div>
                                            </TableCell>
                                            <TableCell align="right" className="">
                                                <div>{Number(row?.loanrequests?.requestamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                            </TableCell>
                                            <TableCell align="center" className="">
                                                <div>{row?.loanrequests?.requestdate}</div>
                                            </TableCell>
                                            <TableCell align="right" className="">
                                                <div>{Number(row?.loanrequests?.requestid).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                            </TableCell>
                                            <TableCell>
                                                <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                                    <MoreVertIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={5}>
                                                <Typography variant="body1" color="textSecondary">
                                                No data available
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={loanList?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />

                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                            <MenuItem
                                onClick={() => {
                                    handleViewDetails(selectedLoan)
                                    handleMenuClose();
                                }}
                            >
                                View Details
                            </MenuItem>
                        </Menu>
                    </Box>
                </>
            }




            <CustomInputAlert
                show={showInputAlert?.showAlert}
                severity={showInputAlert?.severity}
                header={showInputAlert?.header}
                message={showInputAlert?.message}
                alertType={showInputAlert?.alertType}
                inputLabel={showInputAlert?.inputLabel}
                confirmButton={(value) => showInputAlert?.onConfirm(value)} 
                onClick={() => setShowInputAlert(false)}
            />

            <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="sm"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Loan Request Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton
                                onClick={() => setOpenDetailsDialog(false)}
                                sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        {/* Left: Loan Info */}
                                        <Box className="mb-4" flex={1}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    color: "#6b7280",
                                                    fontFamily: "Nunito",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                }}
                                            >
                                                Loan Request Info
                                            </Typography>

                                            {/* Display fields */}
                                            <Box className="info-container">
                                                <Box className="info-type">Request ID:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.requestid}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">User ID:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.userid}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Request Date:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.requestdate}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Loan Type:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.loantype}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Request Amount:</Box>
                                                <Box className="info-response">{Number(selectedLoan?.loanrequests?.requestamount).toLocaleString()}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Current Limit:</Box>
                                                <Box className="info-response">{Number(selectedLoan?.loanrequests?.currentlimit).toLocaleString()}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Current Outstanding Loan:</Box>
                                                <Box className="info-response">{Number(selectedLoan?.loanrequests?.currentoutstandingloan).toLocaleString()}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Approval Status:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.comments || "Pending"}</Box>
                                            </Box>
                                        </Box>

                                        {/* Right: Loan Financial Info */}
                                        <Box flex={1}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    color: "#6b7280",
                                                    fontFamily: "Nunito",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                }}
                                            >
                                                Financial Info
                                            </Typography>

                                            {/* Display fields */}
                                            <Box className="info-container">
                                                <Box className="info-type">Amount For Fee Calculation:</Box>
                                                <Box className="info-response">{Number(selectedLoan?.loanrequests?.amountforfeecalculation).toLocaleString()}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Approved Date:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.approveddate || "N/A"}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Approved By:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.approvedby || "N/A"}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Overridden Interest Amount:</Box>
                                                <Box className="info-response">{Number(selectedLoan?.loanrequests?.overriddeninterestamount).toLocaleString()}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Override Interest:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.overrideinterest === "1" ? "Yes" : "No"}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Other Details:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.otherdetails || "N/A"}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Term Type:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.termtype || "N/A"}</Box>
                                            </Box>
                                            <Box className="info-container">
                                                <Box className="info-type">Last Execution Time:</Box>
                                                <Box className="info-response">{selectedLoan?.loanrequests?.lastexecutiontime || "N/A"}</Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <BaseDrawer
                open={openLoanDetailsDrawer}
                handleClose={() => setOpenLoanDetailsDrawer(false)}
                height="85vh"
            >
                <LoanDetails4Pay selectedLoan={selectedLoan} loanDetailsArr={loanDetailsArr} userLoanPaymentPlans={userLoanPaymentPlans} />
            </BaseDrawer>
        </Box>
    );
};

export default LoansCancelledRequests;
